// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"7d9c146b","840":"49a2941f"}[chunkId] + ".chunk.css";
};